import { CommonModule } from '@angular/common';
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-drop-down',
  imports: [CommonModule, FormsModule, SelectModule, ButtonModule],
  templateUrl: './drop-down.component.html',
  styleUrl: './drop-down.component.scss',
  standalone: true,
})
export class DropDownComponent implements OnChanges {
  @Input({ required: true }) dataSource: object[] = [];
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() value: { name: string; value: string } | null = null;
  @Input() disabled: boolean = false;

  @Output() selectedOption = new EventEmitter<any>();
  @Output() touched = new EventEmitter<void>();
  selectedItem: any = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.selectedItem = this.value;
    }
  }

  onBlur() {
    this.touched.emit();
  }

  onSelect(value: any) {
    this.selectedOption.emit(value);
  }
}
